import { useMemo } from 'react';
import { ResourceRowData } from '@features/components/CaseOverview/components/AssignedResources/types';
import { TmdxUsersTable } from '../TmdxUsersTable/TmdxUsersTable';
import { EmployeeRole, EmployeeStatus, EmployeeSearchOrderBy } from '@/api/apis/resources';
import { useInfiniteEmployeeListQuery } from '@/queries/employee';
import { organSpecificRoles } from '../../../config';
import { OrganType } from '@/api/apis/case';
import { mapTMDXEmployees } from '../../../utils';
import { useInfiniteList } from '@/hooks/useInfiniteList';

export type NonLogisticsEmployeesTableProps = {
  searchTerm: string;
  onTmdxUserAssign: (user: ResourceRowData) => void;
  usersToAssign: Partial<Record<EmployeeRole, string[]>>;
  selectedRole: EmployeeRole;
  organType: OrganType;
};

export const NonLogisticsEmployeesTable = ({
  searchTerm,
  onTmdxUserAssign,
  usersToAssign,
  selectedRole,
  organType,
}: NonLogisticsEmployeesTableProps) => {
  const organTypeIfRequired = organSpecificRoles.includes(selectedRole) ? organType : undefined;

  const { list, hasNextPage, fetchNextPage, isLoading } = useInfiniteList({
    query: useInfiniteEmployeeListQuery,
    queryParams: {
      roles: selectedRole,
      organType: organTypeIfRequired,
      status: EmployeeStatus.Active,
      itemsPerPage: 20,
      orderBy: EmployeeSearchOrderBy.Name,
      asc: true,
    },
    searchTerm,
  });

  const tmdxEmployees = useMemo(() => {
    return list ? mapTMDXEmployees(list, usersToAssign, selectedRole) : [];
  }, [list, usersToAssign, selectedRole]);

  return (
    <TmdxUsersTable
      items={tmdxEmployees}
      onUserAssign={onTmdxUserAssign}
      role={selectedRole}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      loadNextPage={fetchNextPage}
    />
  );
};
